import { filter, ignoreElements, tap } from "rxjs/operators";
import { IdEventSoundCore } from "../../../utils/sound/IdEventSoundCore";
import { utilSound } from "../../../utils/sound/utilSound";
import { TypeActionPlayerInfo } from "../../info/player/actionPlayerInfo";
export var epicSoundsLevelUp = function (action$) {
    return action$.pipe(filter(function (action) { return action.type === TypeActionPlayerInfo.AddLevel; }), tap(function () { return utilSound.event(IdEventSoundCore.LevelUp); }), ignoreElements());
};



//////////////////
// WEBPACK FOOTER
// ./src/features/sound/epics/epicSoundsLevelUp.ts
// module id = 2406
// module chunks = 3